import React, { useState } from 'react';
import AddOutlined from '@mui/icons-material/AddOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';

export default function PersonnelList({
  personnel, selectedId, onSelect, onAdd,
  isLoading, searchQuery, onSearchChange,
}) {
  const [searchFocused, setSearchFocused] = useState(false);
  const [addHover, setAddHover] = useState(false);

  return (
    <div
      style={{
        width: '320px',
        minWidth: '320px',
        height: 'calc(100vh - 56px)',
        backgroundColor: '#2a2a2a',
        borderRight: '1px solid #3a3a3a',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid #3a3a3a',
          backgroundColor: '#222222',
        }}
      >
        {/* Title + Add */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '12px',
          }}
        >
          <span
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 700,
              fontSize: '18px',
              color: '#FFFFFF',
            }}
          >
            Personnel
          </span>
          <div
            onClick={onAdd}
            onMouseEnter={() => setAddHover(true)}
            onMouseLeave={() => setAddHover(false)}
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: addHover ? '#8B1C26' : '#BF2634',
              border: 'none',
              borderRadius: '4px',
              color: '#FFFFFF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.15s ease',
            }}
          >
            <AddOutlined style={{ fontSize: 20 }} />
          </div>
        </div>

        {/* Search */}
        <div style={{ position: 'relative' }}>
          <SearchOutlined
            style={{
              position: 'absolute',
              left: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 18,
              color: '#565656',
              pointerEvents: 'none',
            }}
          />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onFocus={() => setSearchFocused(true)}
            onBlur={() => setSearchFocused(false)}
            placeholder="Search..."
            style={{
              width: '100%',
              backgroundColor: '#1a1a1a',
              border: `1px solid ${searchFocused ? '#39FF14' : '#3a3a3a'}`,
              borderRadius: '4px',
              padding: '10px 12px 10px 36px',
              color: '#F5F5F5',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 400,
              fontSize: '14px',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 0.15s ease',
            }}
          />
        </div>
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
        {isLoading ? (
          <div
            style={{
              padding: '32px',
              textAlign: 'center',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 300,
              fontSize: '14px',
              color: '#888888',
            }}
          >
            Loading...
          </div>
        ) : personnel.length === 0 ? (
          <div
            style={{
              padding: '32px',
              textAlign: 'center',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 300,
              fontSize: '14px',
              color: '#888888',
            }}
          >
            No personnel found
          </div>
        ) : (
          personnel.map((profile) => (
            <PersonnelRow
              key={profile._id}
              profile={profile}
              isSelected={selectedId === profile._id}
              onSelect={onSelect}
            />
          ))
        )}
      </div>
    </div>
  );
}

function PersonnelRow({ profile, isSelected, onSelect }) {
  const [hovered, setHovered] = useState(false);

  const fullName = [profile.first_name, profile.last_name].filter(Boolean).join(' ');
  const visibleDepts = profile.departments?.slice(0, 2) || [];
  const extraCount = (profile.departments?.length || 0) - 2;

  return (
    <div
      onClick={() => onSelect(profile)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '12px 16px',
        cursor: 'pointer',
        borderLeft: isSelected ? '3px solid #39FF14' : '3px solid transparent',
        backgroundColor: isSelected
          ? 'rgba(57, 255, 20, 0.06)'
          : hovered
          ? 'rgba(255,255,255,0.03)'
          : 'transparent',
        borderBottom: '1px solid rgba(255,255,255,0.04)',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        transition: 'all 0.15s ease',
      }}
    >
      <div
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 500,
          fontSize: '15px',
          color: '#F5F5F5',
        }}
      >
        {fullName || '—'}
      </div>

      {profile.company?.name && (
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: '13px',
            color: '#888888',
          }}
        >
          {profile.company.name}
        </div>
      )}

      {profile.cell_phone && (
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: '13px',
            color: '#565656',
          }}
        >
          {profile.cell_phone}
        </div>
      )}

      {profile.primary_email && (
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: '12px',
            color: '#565656',
          }}
        >
          {profile.primary_email}
        </div>
      )}

      {visibleDepts.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '2px' }}>
          {visibleDepts.map((d, i) => (
            <span
              key={i}
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                color: '#888888',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 500,
                fontSize: '11px',
                padding: '2px 8px',
                borderRadius: '10px',
              }}
            >
              {d}
            </span>
          ))}
          {extraCount > 0 && (
            <span
              style={{
                backgroundColor: 'rgba(255,255,255,0.06)',
                color: '#888888',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: 500,
                fontSize: '11px',
                padding: '2px 8px',
                borderRadius: '10px',
              }}
            >
              +{extraCount} more
            </span>
          )}
        </div>
      )}
    </div>
  );
}
